import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions as globalErrorActions } from '../../ducks/globalError';
import * as Icons from '../Icons';
import { injectIntl } from 'react-intl';
const Styles = styled.div `
  display: grid;
  grid-template-rows: auto auto auto;
  grid-template-columns: auto auto;
  position: fixed;
  padding: 10px;
  top: 64px;
  right: 20px;
  margin-left: 10px;
  background: ${(props) => props.theme.red};
  z-index: 1000;
  font-size: ${(props) => props.theme.fontSmall};
  color: white;
  border-radius: 4px;
  max-width: 450px;

  @media ${(props) => props.theme.md} {
    top: 72px;
  }

  @media ${(props) => props.theme.xxl} {
    right: ${(props) => props.rightMargin}px;
  }
  @media ${(props) => props.theme.md} {
    width: 450px;
  }
`;
const Title = styled.div `
  font-size: ${(props) => props.theme.fontMedium};
  font-weight: ${(props) => props.theme.bold};
`;
const Body = styled.div `
  grid-row-start: 2;
`;
const Close = styled.div `
  grid-row: 1 / -1;
  align-self: center;
  cursor: pointer;
  padding: 6px;
  margin-left: 15px;
  justify-self: end;
`;
const ErrorCode = styled.div `
  display: flex;
  flex-direction: column;
  & > :first-child {
    margin: 6px 0;
  }
`;
class ErrorPopup extends Component {
    constructor() {
        super(...arguments);
        this.rightMargin = (window.innerWidth - 1920) / 2 + 15;
    }
    render() {
        const { active, title, body, errorCode, exceptionId, GLOBAL_ERROR_ACTIONS, translations, intl: { formatMessage }, } = this.props;
        return (active && (React.createElement(Styles, { rightMargin: this.rightMargin },
            React.createElement(Title, null, title && formatMessage(translations[title])),
            React.createElement(Body, null, body && formatMessage(translations[body])),
            errorCode && (React.createElement(ErrorCode, null,
                React.createElement("span", null,
                    formatMessage(translations.errorCode),
                    " ",
                    errorCode),
                React.createElement("span", null, formatMessage(translations.errorCodeInfo)),
                React.createElement("span", null,
                    "Exception ID: ",
                    exceptionId))),
            React.createElement(Close, { onClick: () => GLOBAL_ERROR_ACTIONS.TOGGLE_OFF() },
                React.createElement(Icons.Cross, null)))));
    }
}
ErrorPopup.defaultProps = {
    errorCode: null,
    exceptionId: null,
};
const mapStateToProps = (state) => {
    return {
        active: state.globalError.get('active'),
        title: state.globalError.get('title'),
        body: state.globalError.get('body'),
        exceptionId: state.globalError.get('exceptionId'),
        errorCode: state.globalError.get('errorCode'),
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        GLOBAL_ERROR_ACTIONS: bindActionCreators(globalErrorActions, dispatch),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(ErrorPopup));
